import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'

import Amplify from 'aws-amplify'
import config from './aws-exports'
import { TripProvider } from './context/TripContext'
import { HeroProvider } from './context/HeroContext'
import { ContentProvider } from './context/ContentContext'
Amplify.configure(config)

ReactDOM.render(
  <BrowserRouter>
    <Router>
      <AuthProvider>
        <TripProvider>
          <ContentProvider>
            <HeroProvider>
              <App />
            </HeroProvider>
          </ContentProvider>
        </TripProvider>
      </AuthProvider>
    </Router>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
